import { MdBarChart, MdSchool, MdPeople } from "react-icons/md";

// Admin pages
import Prediction from "./views/admin/prediction";
import Training from "./views/admin/training";
import UserManagement from "./views/admin/userManagement";
import Profile from "./views/admin/profile";

// Auth pages
import SignInPage from "./views/auth/signIn/SignInPage";
import SignUpPage from "./views/auth/signUp/SignUpPage";
import ForgotPasswordPage from "./views/auth/forgotPassword/ForgotPasswordPage";
import AdminLogin from "./views/auth/adminLogin";
import PredictionResult from "./views/admin/prediction/result";


export const adminRoutes = [
  {
    name: "예측",
    layout: "/admin",
    path: "prediction",
    icon: MdBarChart,
    element: <Prediction />,
  },
  {
    name: "학습",
    layout: "/admin",
    path: "training",
    icon: MdSchool,
    element: <Training />,
  },
  {
    name: "사용자",
    layout: "/admin",
    path: "users",
    icon: MdPeople,
    element: <UserManagement />,
  },
  {
    name: "프로필",
    layout: "/admin",
    path: "profile",
    icon: null,
    element: <Profile />,
    hidden: true,
  },
  {
    name: "예측결과",
    layout: "/admin",
    path: "prediction/result/:runId",
    element: <PredictionResult />,
    icon: null,                      // (옵션) 아이콘 제거
    hidden: true                     // 사이드바에서 숨김
  },
];

export const authRoutes = [
  { name: "Sign In", layout: "/auth", path: "sign-in", element: <SignInPage /> },
  { name: "Sign Up", layout: "/auth", path: "sign-up", element: <SignUpPage /> },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    name: "Admin Login",
    layout: "/auth",
    path: "admin-login",
    element: <AdminLogin />,
  },
];

const routes = [...adminRoutes, ...authRoutes];
export default routes;
